<template>
  <div class="header-container">
    <div v-if="isMobileBrowser" class="mobile-menu-btn" @click="toggleMobileSidebar">
      <van-icon name="wap-nav" size="22" />
    </div>
    <div class="header-content">
      <span class="header-slogan">{{ $t('slogan_short') }}</span>
    </div>
    <div style="display: flex; gap:10px; align-items: center;">
      <div v-if="isLoggedIn && user.userName" class="user-info" @click="handlePersonalCenter">
        <img v-if="user.avatar || user.avatarUrl" :src="$common.getFullImageUrl(user.avatar || user.avatarUrl, $config, 's')"
          class="user-avatar" />
        {{ user.userName }}
      </div>
      <div v-else class="login-btn" @click="handleLogin">
        {{ $t('login') }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import LanguageSwitcher from './LanguageSwitcher.vue'
import { Toast } from 'vant'
import { isMobileBrowser } from '@/utils/mobile-detect.js'

Vue.use(Toast)

export default {
  name: 'Header',
  components: {
    LanguageSwitcher
  },
  props: {
    isMobileBrowser: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDownloadDropdown: false,
      googlePlayUrl: 'https://play.google.com/store/apps/details?id=ai.octopie.client'
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.alreadyLogin
    },
    user() {
      return this.$store.state.user || {}
    },
    isCnRegion() {
      return this.$config && this.$config.region === 'cn'
    },
    appStoreUrl() {
      return this.isCnRegion
        ? 'https://apps.apple.com/cn/app/章摇摇/id6760103197'
        : 'https://apps.apple.com/us/app/octopie-ai/id6760101997'
    },
    apkUrl() {
      return this.isCnRegion
        ? 'https://download.octopie.cn/octopie_cn.apk'
        : 'https://download.octosay.ai/octopie_ai.apk'
    },

  },
  mounted() {
    document.addEventListener('click', this.closeDownloadDropdown)
    this.setupWebSocketListeners()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDownloadDropdown)
    this.removeWebSocketListeners()
  },
  methods: {
    setupWebSocketListeners() {
    },
    removeWebSocketListeners() {
    },
    toggleDownload() {
      this.showDownloadDropdown = !this.showDownloadDropdown
    },
    closeDownloadDropdown(e) {
      if (!this.$el.contains(e.target)) {
        this.showDownloadDropdown = false
      }
    },
    handleLogin() {
      this.$store.state.needLogin = true
    },
    handlePersonalCenter() {
      const url = `/app/#/personal-center`
      window.open(url, '_blank')
    },
    toggleMobileSidebar() {
      this.$emit('toggle-mobile-sidebar')
    }
  }
}
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: #fff;
  border-bottom: 1px solid #E0DDD8;
  position: sticky;
  top: 0;
  z-index: 50;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 1;
}

.header-slogan {
  font-size: 14px;
  font-weight: 500;
  color: #4A4A4A;
  font-style: italic;
  padding-left: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 0.875rem;
  color: #4A4A4A;
  font-weight: 500;
  background: #F7F5F2;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: #E0DDD8;
  color: #1A1A1A;
}

.user-avatar {
  width: 24px;
  height: 24px;
  border-radius: 16%;
  object-fit: cover;
}

.login-btn {
  padding: 6px 16px;
  background: #E8543A;
  color: white;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.login-btn:hover {
  background: #C93E1A;
}

.mobile-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin-left: -8px;
  cursor: pointer;
  color: #1A1A1A;
  border-radius: 8px;
  transition: background 0.2s;
}

.mobile-menu-btn:hover {
  background: #F7F5F2;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue